import { render, staticRenderFns } from "./ArticleSerialNumberHistoryModal.vue?vue&type=template&id=298378a5&"
import script from "./ArticleSerialNumberHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ArticleSerialNumberHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports